import { API } from '@Providers';

export default async function (status?: string) {
  const endpoint = `/api/shelter/groups/get-all/${status || 'all'}`;

  return API({ endpoint });
}
